import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {AppBar, Box, IconButton, Input, TextField, Toolbar} from '@mui/material'
import {
    ArrowBackRounded as ArrowBackIcon,
    MenuRounded as MenuIcon,
    CloseRounded as CloseIcon,
    SearchRounded as SearchIcon,
    ExpandLessRounded,
    ExpandMoreRounded
} from '@mui/icons-material'
import {toolbarColor} from '../../metrics.module.scss'

import './headers.scss'

import {general as textsGeneral} from '../../translate/Translate.jsx'
import {getLocal} from "../../hooks/useStorage/useStorage.jsx";

const Header = ({
                    home = false,
                    title,
                    buttonMenu = false,
                    buttonBack = false,
                    buttonSearch = false,
                    onClick,
                    onChange,
                    onClickNextPreviousSearch
                }) => {
    const [search, setSearch] = useState(false)
    const [textSearch, setTextSearch] = useState('')
    const navigate = useNavigate()
    const handleClickBack = () => navigate(-1)
    const handleClickSearch = () => {
        setSearch(!search)
        setTextSearch('')
        onChange('')
    }
    const handleChange = (e) => {
        setTextSearch(e.target.value)
        onChange(e.target.value)
    }
    const info = getLocal('info')
    return <AppBar elevation={0} id={(home && !search) ? 'app-bar-not-fixed' : search ? 'app-search' : 'app-bar'}
                   style={{backgroundColor: toolbarColor}}>
        <Toolbar className={'toolbar'}>
            <div className={'div-toolbar'}>
                {(buttonMenu) && <IconButton sx={{mr: 2}} edge={'start'} onClick={() => onClick()}>
                    <MenuIcon className={'icon-header'}/>
                </IconButton>}
                {(buttonBack) && <IconButton sx={{mr: 2}} edge={'start'} onClick={() => handleClickBack()}>
                    <ArrowBackIcon className={'icon-header'}/>
                </IconButton>}
                {!search && <label className={'label-header'}>
                    {info?.name || title}
                </label>}
            </div>
            <div className={'div-toolbar'}>
                {search && <Box className={'box-search'}>
                    <div className={'div-close-button'}>
                        <CloseIcon className={'icon-search'} onClick={handleClickSearch}/>
                    </div>
                    <Input
                        autoFocus={true}
                        sx={{
                            '& .MuiInputBase-input': {padding: '8px', color: '#1e1e1e'},
                            '&:before, &:after': {display: 'none'}
                        }}
                        placeholder={textsGeneral.search}
                        label={textsGeneral.search}
                        onChange={handleChange}
                    />
                    <div className={'div-expand-buttons'}>
                        <ExpandLessRounded className={'icon-search'} onClick={() => onClickNextPreviousSearch(false)}/>
                        <ExpandMoreRounded className={'icon-search'} onClick={() => onClickNextPreviousSearch(true)}/>
                    </div>
                </Box>}
                {(buttonSearch) && <IconButton edge={'end'} onClick={handleClickSearch}>
                    <SearchIcon className={'icon-header'}/>
                </IconButton>}
            </div>
        </Toolbar>
    </AppBar>
}

export default Header
